/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_2Inputs */

const en_cp_lead_get_2 = /** @type {(inputs: Cp_Lead_Get_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club credits worth Rp 100k/month for your build-night attendees`)
};

const id_cp_lead_get_2 = /** @type {(inputs: Cp_Lead_Get_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit klub Rp 100 rb/bulan untuk peserta build night-mu`)
};

/**
* | output |
* | --- |
* | "Club credits worth Rp 100k/month for your build-night attendees" |
*
* @param {Cp_Lead_Get_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_2 = /** @type {((inputs?: Cp_Lead_Get_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_2(inputs)
	return en_cp_lead_get_2(inputs)
});